import { useCallback } from 'react';

import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';
import { useListController } from '@ocx-app/hooks/useListController';
import { IStoreCarWashOption } from '@ocx-app/modules/stores/types';

export const useCarWashController = ({ rawCarWashOptions }: { rawCarWashOptions: IStoreCarWashOption[] }) => {
  const { triggerEvent } = useRudderStack();

  const onSelectCarWash = useCallback(() => {
    triggerEvent('pay_at_pump_carwash');
  }, [triggerEvent]);

  const carWashListController = useListController<IStoreCarWashOption>({
    listItems: rawCarWashOptions,
    onSelect: onSelectCarWash,
  });

  return { carWashListController };
};
